export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-burst-sale-72f1a583057d0b61fc368ade35c7cf32.svg";